import { render, staticRenderFns } from "./ShopperSelectModal.vue?vue&type=template&id=8363584c&scoped=true&"
import script from "./ShopperSelectModal.vue?vue&type=script&lang=js&"
export * from "./ShopperSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopperSelectModal.vue?vue&type=style&index=0&id=8363584c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363584c",
  null
  
)

export default component.exports